
window.taskFormDates = {
    datetimeTypeSelect: {},
    rangeCalendor: {},
    simpleCalendors: {},

    init: function() {
        this.rangeCalendor = $('#first-range-task-date').flatpickr({
            plugins: [new rangePlugin({ input: '#second-range-task-date'})],
            enableTime: true,
            time_24hr: true,
            dateFormat: "Y-m-d H:i",
            minDate: 'today'
        });

        this.simpleCalendors = $(".datetimepicker").flatpickr({
            minDate: 'today',
            enableTime: true,
            time_24hr: true,
            dateFormat: "Y-m-d H:i",
        });
        
        this.datetimeTypeSelect = $("select.custom-js-select");
        
        this.datetimeTypeSelect.select2({
            minimumResultsForSearch: -1,
            language: "lt-LT",
            placeholder: function(){
                $(this).data('placeholder');
            }
        });

        this.bindEvents();

        $(this.datetimeTypeSelect).trigger({
            type: 'select2-loaded',
            params: {
                data: $(this.datetimeTypeSelect).select2('data')[0]
            }
        });
    },

    updateDatetimeFields: function(selector) {
        // Remove name fields
        $('.date-field input').each( (index, element) => {
            $(element).removeAttr('name');
        });
        
        // Hide all fields 
        $('.date-field').each( (index, element) => {
            if(!$(element).hasClass('d-none')) {
                $(element).addClass('d-none');
            }
        });

        // Show only selected type & set name attribute
        $(selector).toggleClass('d-none');
        $(selector + ' input').each( (index, element) => {
            $(element).attr('name', $(element).data('name'));
        });
    },

    bindEvents: function() {
        this.datetimeTypeSelect.on('select2-loaded', function (e) {
            var data = e.params.data;
            var selector = '.' + data.id;

            taskFormDates.updateDatetimeFields(selector);
        });

        this.datetimeTypeSelect.on('select2:select', function(e){
            var data = e.params.data;
            var selector = '.' + data.id;

            taskFormDates.updateDatetimeFields(selector);

            taskFormDates.rangeCalendor.clear();
            $(taskFormDates.simpleCalendors).each((index, calendor) => {
                calendor.clear();
            });
        });
    }
}